import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'leads-receptions-dashboard-unqualified-reasons',
  storeModule.createStoreModule('leads-receptions-dashboard-unqualified-reasons', {
    fetchListURL: 'leads-receptions/dashboard/unqualified-reasons'
  })
)
